<template>
  <div class="frame-wrapper-subsection">
    <div class="frame-3">
      <div class="text-wrapper-2">Pourquoi choisir Florisuite ?</div>
      <div class="frame-4">
        <PropertyDefaultWrapper
          class="container"
          heartHandshake="https://c.animaapp.com/nNxA75tB/img/heart-handshake-2.svg"
          property1="default"
        />
        <Container2
          class="container"
          handshake="https://c.animaapp.com/nNxA75tB/img/handshake-2.svg"
          property1="default"
        />
        <Container3
          badgeEuroSign=""
          class="container"
          property1="default"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Container2 from "../../../components/Container2.vue";
import Container3 from "../../../components/Container3.vue";
import PropertyDefaultWrapper from "../../../components/PropertyDefaultWrapper.vue";

export default defineComponent({
  name: "FrameWrapperSubsection",
  components: {
    Container2,
    Container3,
    PropertyDefaultWrapper,
  },
});
</script>

<style>
.frame-wrapper-subsection {
  align-items: center;
  align-self: stretch;
  border: 0px none;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 100px 30px;
  position: relative;
  width: 100%;
}

.frame-wrapper-subsection .frame-3 {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 50px;
  justify-content: center;
  max-width: 1200px;
  position: relative;
  width: 100%;
}

.frame-wrapper-subsection .text-wrapper-2 {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 40px;
  margin-top: -1.00px;
  position: relative;
  text-align: center;
}

.frame-wrapper-subsection .frame-4 {
  align-items: center;
  align-self: stretch;
  display: grid;
  gap: 31px 31px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  min-width: 0;
  position: relative;
  width: 100%;
}

.frame-wrapper-subsection .container {
  left: unset !important;
  min-width: 0 !important;
  top: unset !important;
  width: 100% !important;
  max-width: none !important;
}

@media (max-width: 1024px) {
  .frame-wrapper-subsection {
    padding: 80px 20px;
  }

  .frame-wrapper-subsection .frame-4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .frame-wrapper-subsection {
    padding: 56px 16px;
  }

  .frame-wrapper-subsection .frame-3 {
    gap: 28px;
  }

  .frame-wrapper-subsection .text-wrapper-2 {
    font-size: 30px;
    line-height: 1.2;
    margin-top: 0;
  }

  .frame-wrapper-subsection .frame-4 {
    gap: 16px;
    grid-template-columns: 1fr;
  }
}
</style>
